import { createContext } from 'react';
import { INavigationMenuItem } from 'types';

interface INavigationMenuItems {
    menuItems: INavigationMenuItem[];
}

export const MenuItemsContext = createContext<INavigationMenuItems>({
    menuItems: []
});
